import * as React from 'react';
import { clsx } from 'clsx';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Затеняющая подложка
 */
export function Overlay(_ref) {
  let {
    children,
    zIndex,
    outside,
    onClose,
    print
  } = _ref;
  const onClick = React.useCallback(e => {
    if (outside && e.currentTarget === e.target) {
      onClose();
    }
  }, [onClose, outside]);
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['overlay'], !print && styles['no-print']),
    style: {
      zIndex
    },
    onMouseDown: onClick,
    children: children
  });
}